const SearchBar = () => {
    const domElements = {
        trigger: document.querySelector(".js-search-trigger"),
    };
    if (!domElements.trigger)
        return;
    let isActive = false;
    const parent = domElements.trigger.parentElement;
    const input = parent.querySelector("input");
    if (!parent || !input)
        return;
    const handleClickEvents = () => {
        if (!domElements.trigger)
            return;
        if (isActive && input.value.length > 0) {
            parent.submit();
            return;
        }
        parent.classList.toggle("is-active");
        isActive = !isActive;
    };
    domElements.trigger.addEventListener("click", handleClickEvents);
};
export default SearchBar;
